import { axios } from '@/utils/request'
const api = "/User"
export default {
  user_list: (parameter) => {
    return axios({
      url: `${api}/user_list`,
      method: 'post',
      data: parameter
    })
  },
  DelteUser: (parameter) => {
    return axios({
      url: `${api}/DelteUser`,
      method: 'post',
      data: parameter
    })
  },
  SaveUser: (parameter) => {
    return axios({
      url: `${api}/SaveUser`,
      method: 'post',
      data: parameter
    })
  },
  drawExport: (parameter) => {
    return axios({
      url: `${api}/drawExport`,
      method: 'post',
      data: parameter
    })
  },
  blockUser: (parameter) => {
    return axios({
      url: `${api}/blockUser`,
      method: 'post',
      data: parameter
    })
  },
  unblockUser: (parameter) => {
    return axios({
      url: `${api}/unblockUser`,
      method: 'post',
      data: parameter
    })
  },
  census: (parameter) => {
    return axios({
      url: `${api}/census`,
      method: 'post',
      data: parameter
    })
  },
}